export const PATIENT_STATUS = {
    DECEASED: 'Deceased',
    INACTIVE: 'InActive',
};
